// extracted by mini-css-extract-plugin
export default {"icon":"relatedProductsEdit_icon__GLgwH"};